import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ChaseIqUpgradeTooltip from "../../../../shared/chaseIqUpgradeTooltip/ChaseIqUpgradeTooltip";
import { useChaseIqAccess } from "../../../../hooks/useChaseIqAccess";
import { actionCreators } from "../redux/totalRevenueSalesSagas";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { AILogoIcon } from "../../../../assets/images/svg";

const PredictionToggle = () => {
  const dispatch = useDispatch();
  const showPrediction = useSelector((state) => state.totalRevenueSales.showPrediction);
  const hasAIAccess = useChaseIqAccess();

  const handleToggle = (val) => {
    if (!hasAIAccess) return;
    dispatch(actionCreators.togglePrediction(val));
  };

  return (
    <div className="select-box-no-width prediction-toggle">
      <p>
        Prediction by <AILogoIcon className="chaseiq-logo-inline" /> ChaseIQ
      </p>
      <div>
        <ToggleableButton
          isRadio
          isActive={showPrediction}
          title="chaseiq-prediction"
          onClick={handleToggle}
        />
        {!hasAIAccess && (
          <ChaseIqUpgradeTooltip anchorSelect="label[for='section-toggle-chaseiq-prediction']" />
        )}
      </div>
    </div>
  );
};

export default PredictionToggle;
